module.exports = __webpack_public_path__ + "img/catfood_logo2019.b9eb456e.png";